<div
  class="card shadow-1 flex flex-column"
  [style.borderColor]="metric().colorDark"
  [style]="{
    'border-color': metric().colorDark,
    'border-left': '4px solid',
  }"
>
  <div class="flex align-items-center">
    <div
      class="flex justify-content-center align-items-center p-2 border-round"
      [style.backgroundColor]="metric().colorLight"
    >
      <i [class]="metric().icon" [style.color]="metric().colorDark"></i>
    </div>
    <div style="display: inline-flex; justify-content: space-between">
      <span
        class="text-xl ml-2 font-semibold"
        [style.color]="metric().colorDark"
      >
        {{ title }}
      </span>
      @if (helpText) {
        <button
          pButton
          pRipple
          type="button"
          icon="icon-circle-question-mark"
          class="p-button-rounded p-button-text text-xl pt-0"
          [pTooltip]="helpText"
          tooltipPosition="bottom"
          placeholder="Right"
        ></button>
      }
    </div>
  </div>
  <div class="grid mt-1">
    <div class="col-12">
      @if (loading) {
        <p-skeleton height="1rem" styleClass="m-0" borderRadius="6px" />
      } @else {
        <p-meterGroup [value]="metric().values" styleClass="h-1rem">
          <ng-template pTemplate="label"></ng-template>
          <ng-template
            pTemplate="meter"
            let-value
            let-class="class"
            let-width="size"
            let-color="color"
          >
            <span
              [class]="class"
              [style]="{
                width: width,
                background: value.color,
                border: '1px solid',
                borderColor: ColorUtils.darken(value.color),
              }"
              [pTooltip]="value.tooltip"
              tooltipPosition="top"
            ></span>
          </ng-template>
        </p-meterGroup>
      }
    </div>
  </div>
</div>
